/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback } from "react";
import {
  Container,
  AppBar,
  Toolbar,
  Card,
  CardMedia,
  IconButton,
  Box,
  Typography,
  Button,
  List,
  ListItem,
  CircularProgress,
  TextField,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Chip,
  Link,
  InputAdornment,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Work as WorkIcon, Task as TaskIcon, Sort as SortIcon, WorkOff as WorkOffIcon, Lock as LockIcon, Star as StarIcon } from "@mui/icons-material";
import { formatDistanceToNow } from "date-fns";
import { es } from "date-fns/locale";
import { isLoggedIn } from "../session";
import { auth, db, getToken, messaging } from "../firebase";
import {
  collection,
  onSnapshot,
  query,
  orderBy,
  getDocs,
  addDoc,
  where,
  getDoc,
  doc,
} from "firebase/firestore";
import logoSvg from "../imgs/logo_border.png";
import { requestNotificationPermission } from "./requestNotificationPermission";
import NotificationIcon, { subscribeToNotifications } from "./NotificationIcon";
import {
  useListenForNewChatMessages,
  useListenForProjectSkills,
  useListenForNewProposals,
} from "./listen";
import BottomNav from "./BottomNav";
import { styled } from "@mui/material/styles";
import ProtectedPublishButton  from "./protectedPublish";
import { useSubscriptionContext } from "./SubscriptionContext";
import { getTierInfo } from "./membershipTiers";

const TruncatedTypography = styled(Typography)(({ theme }) => ({
  textAlign: "justify",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  lineHeight: "1.5em",
  maxHeight: "4.5em", // 3 lines * 1.5em line-height
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Home = () => {
  const { subscription } = useSubscriptionContext();
  const myTier = getTierInfo(subscription);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [searchTerm, setSearchTerm] = useState("");
  const [authUserId, setAuthUserId] = useState(null);
  const [skills, setSkills] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [categories, setCategories] = useState([
    "Diseño Grafico",
    "Programación",
    "Marketing Digital",
    "Redacción De Contenidos",
    "Traducción",
    "Diseño Web",
  ]);
  const navigate = useNavigate();
  const [uid, setUid] = useState(null);
  const [proposals, setProposals] = useState([]);
  const [open, setOpen] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogCC, setShowDialogCC] = useState(false);
  const [hasNewNotifications, setHasNewNotifications] = useState(false);
  const [projectIcons, setProjectIcons] = useState({});
  const [freelancers, setFreelancers] = useState([]);
  const [nameSearch, setNameSearch] = useState("");
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [allSkills, setAllSkills] = useState([]);
  const [sortBy, setSortBy] = useState("recent");

  useEffect(() => {
    // Suscribirse a notificaciones al montar el componente
    const unsubscribe = subscribeToNotifications(setHasNewNotifications);

    // Desuscribirse al desmontar el componente
    return () => unsubscribe && unsubscribe();
  }, []);

  useEffect(() => {
    const checkAuthAndRequestPermission = async () => {
      const loggedIn = await isLoggedIn();
      setUserAuthenticated(loggedIn);
      setLoading(false);

      if (loggedIn) {
        await requestNotificationPermission(messaging);
      }
    };

    checkAuthAndRequestPermission();
  }, []);

  const [userAuthenticated, setUserAuthenticated] = useState(false);

  useListenForNewChatMessages();

  useListenForProjectSkills();

  useListenForNewProposals();

  useEffect(() => {
    const fetchData = async () => {
      if (!auth.currentUser) return;
      
      try {
        setLoading(true);

        // Fetch projects
        const projectsCollectionRef = collection(db, "projects");
        const unsubscribe = onSnapshot(
          query(projectsCollectionRef, orderBy("createdAt", "desc")),
          async (snapshot) => {
            const projectsData = snapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));
            setProjects(projectsData);
  
            // Extraer habilidades únicas
            const uniqueSkills = [
              ...new Set(
                projectsData.flatMap((project) =>
                  Array.isArray(project.skills)
                    ? project.skills
                    : [project.skills]
                )
              ),
            ];
            setAllSkills(uniqueSkills);
          }
        );
  
        setLoading(false);
        return () => unsubscribe();
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };
  
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.currentUser, db]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true);
        const projectsCollectionRef = collection(db, "projects");
        const unsubscribe = onSnapshot(
          query(projectsCollectionRef, orderBy("createdAt", "desc")),
          async (snapshot) => {
            const projectsData = snapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));
            setProjects(projectsData);

            // Extraer habilidades únicas de todos los proyectos
            const uniqueSkills = [
              ...new Set(
                projectsData.flatMap((project) =>
                  Array.isArray(project.skills)
                    ? project.skills
                    : [project.skills]
                )
              ),
            ];
            setAllSkills(uniqueSkills);

            setLoading(false);
          }
        );
        return () => unsubscribe();
      } catch (error) {
        console.error("Error al obtener proyectos:", error);
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  const handleNameSearchChange = (event) => {
    setNameSearch(event.target.value);
  };

  const handleSkillChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedSkills(typeof value === "string" ? value.split(",") : value);
  };

  useEffect(() => {
    const checkAuthAndFetchProposals = async () => {
      if (!isLoggedIn()) {
        navigate("/login");
        return;
      }

      try {
        const token = await getToken();
        if (!token) {
          console.error("No se pudo obtener el token de autenticación.");
          return;
        }
        const currentUser = auth.currentUser;
        if (!currentUser) {
          console.error("No hay un usuario autenticado.");
          return;
        }
        const { uid } = currentUser;
        setUid(uid);
        setAuthUserId(uid); // Set authUserId to the current user's uid
        setLoading(true);

        // Obtener el userType desde la colección users
        const userDocRef = doc(db, "users", uid);
        const userDocSnapshot = await getDoc(userDocRef);
        if (!userDocSnapshot.exists()) {
          console.error("El documento de usuario no existe.");
          setLoading(false);
          return;
        }
        const userData = userDocSnapshot.data();
        if (!userData.userType) {
          console.warn("No se encontró userType para el usuario; se omite la creación de notificaciones.");
        }
        const userType = userData.userType || null;

        const projectsSnapshot = await getDocs(collection(db, "projects"));
        const allProposals = [];
        for (const projectDoc of projectsSnapshot.docs) {
          const projectId = projectDoc.id;
          const projectData = projectDoc.data(); // Obtener datos del proyecto
          const proposalsSnapshot = await getDocs(
            collection(db, "projects", projectId, "proposals")
          );
          const projectProposals = proposalsSnapshot.docs.map((doc) => {
            const data = doc.data();
            return {
              ...data,
              id: doc.id,
              uid: data.uid,
              projectId: projectId,
            };
          });
          allProposals.push(...projectProposals);
        }

        setProposals(allProposals);

        // Crear notificaciones para las nuevas propuestas
        const newNotifications = [];
        let hasUnreadNotifications = false;
        for (const proposal of allProposals) {
          // Evitar crear notificación para el propio freelancer
          if (proposal.uid === uid) {
            continue;
          }
          const notificationQuery = query(
            collection(db, "notifications"),
            where("idDoc", "==", proposal.id)
          );
          const notificationSnapshot = await getDocs(notificationQuery);
          if (notificationSnapshot.empty) {
            // Obtener el id del usuario dueño del proyecto (cliente)
            const projectDocRef = doc(db, "projects", proposal.projectId);
            const projectDocSnapshot = await getDoc(projectDocRef);
            if (!projectDocSnapshot.exists()) {
              console.error("El documento del proyecto no existe.");
              continue;
            }
            const projectData = projectDocSnapshot.data();
            const clientUid = projectData.uid; // Suponiendo que el campo uid representa al dueño del proyecto

            // Crear una notificación solo si el usuario autenticado es el dueño del proyecto
            if (userType === "cliente" && uid === clientUid) {
              const notificationData = {
                userId: clientUid, // Ahora, userId es el dueño del proyecto
                idDoc: proposal.id,
                userType: userType,
                read: false,
              };
              newNotifications.push(notificationData);
              // Guardar la notificación en Firestore
              await addDoc(collection(db, "notifications"), notificationData);

              hasUnreadNotifications = true; // Marcar que hay notificaciones no leídas
            }
          }
        }
        setHasNewNotifications(hasUnreadNotifications);
        setLoading(false);
      } catch (error) {
        console.error("Error al obtener propuestas:", error);
        setLoading(false);
      }
    };
    checkAuthAndFetchProposals();
  }, [navigate]);

  useEffect(() => {
    const fetchAuthUserId = async () => {
      const isAuthenticated = await isLoggedIn();
      const { uid } = auth.currentUser || {};
      setAuthUserId(isAuthenticated ? uid : null);
    };
    fetchAuthUserId();
  }, []);

  useEffect(() => {
    const filteredProjects = projects.filter(
      (project) =>
        project.title.toLowerCase().includes(nameSearch.toLowerCase()) &&
        (project.status || "abierto") === "abierto" &&
        (selectedSkills.length === 0 ||
          selectedSkills.some(
            (skill) =>
              project.skills.includes(skill) ||
              (typeof project.skills === "string" &&
                project.skills.includes(skill))
          ))
    );

    const sorted = [...filteredProjects].sort((a, b) => {
      if (sortBy === "priceHigh") return (Number(b.price) || 0) - (Number(a.price) || 0);
      if (sortBy === "priceLow") return (Number(a.price) || 0) - (Number(b.price) || 0);
      return 0; // "recent": ya vienen ordenados por createdAt desc
    });

    const isFeaturedActive = (project) =>
      project.featured && project.featuredUntil && project.featuredUntil.toDate() > new Date();

    // Los proyectos destacados (pagos) aparecen primero, preservando el orden elegido dentro de cada grupo.
    const withFeaturedBoost = [...sorted].sort(
      (a, b) => (isFeaturedActive(b) ? 1 : 0) - (isFeaturedActive(a) ? 1 : 0)
    );

    setFilteredResults(withFeaturedBoost);
  }, [nameSearch, selectedSkills, projects, sortBy]);

  const isFeaturedActive = (project) =>
    project.featured && project.featuredUntil && project.featuredUntil.toDate() > new Date();

  const formatDate = (timeToDo) => {
    if (timeToDo instanceof Date) {
      return timeToDo.toLocaleDateString();
    } else if (timeToDo && timeToDo.toDate instanceof Function) {
      return timeToDo.toDate().toLocaleDateString();
    }
    return "";
  };

  const handleProject = (projectId) => {
    return () => {
      navigate(`/project/${projectId}`);
    };
  };

  const styles = {
    img: {
      maxWidth: "150px",
      maxHeight: "40px",
      display: "block",
      margin: "20px auto",
    },
    slogan: {
      color: "text.secondary",
      fontSize: "14px",
      fontWeight: "bold",
    },
    iconContainer: {
      display: "flex",
      width: "100%",
      borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      justifyContent: "space-around",
      color: "text.secondary",
    },
    buscar: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%",
    },
    title: {
      fontSize: "24px",
      color: "primary.main",
      marginBottom: "7px",
    },
    description: {
      fontSize: "18px",
      marginBottom: "7px",
      width: "100%",
    },
    timeToDo: {
      color: "success.main",
      fontSize: "15px",
      marginBottom: "7px",
      fontFamily: (theme) => theme.custom.fontMono,
    },
    skills: {
      marginBottom: "7px",
    },
    price: {
      color: "success.main",
      marginBottom: "7px",
      fontFamily: (theme) => theme.custom.fontMono,
    },
    created: {
      fontSize: "10px",
      marginBottom: "7px",
      color: "text.secondary",
    },
    media: {
      width: "190px",
      marginTop: "25px",
    },
  };

  return (
    <Container>
      <Dialog open={showDialogCC} onClose={() => setShowDialogCC(false)}>
        <DialogTitle>¡Hazte miembro de la red!</DialogTitle>
        <DialogContent>
          <Button href="/membership" fullWidth variant="outlined">
            Obtener Membresia
          </Button>
        </DialogContent>
      </Dialog>
      <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
        <DialogTitle>¡Pago exitoso!</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Su pago ha sido procesado con éxito.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDialog(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      <AppBar
        position="fixed"
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        <Toolbar
          sx={{ flexDirection: "column", width: "100%", alignItems: "center" }}
        >
          <CardMedia
            component="img"
            image={logoSvg} // Utilizar la variable que contiene la imagen SVG
            title="Skach"
            style={styles.media} // Especificar estilos si es necesario
          />
          <Box>
            <Typography variant="h6" sx={styles.slogan}>
              ¡Crea un proyecto o busca uno!
            </Typography>
          </Box>
          <Toolbar sx={styles.iconContainer}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <IconButton href="/proyectos" sx={{ color: "text.secondary" }}>
                <WorkIcon />
              </IconButton>
              <Typography variant="caption" fontSize={9} align="center">
                Mis Proyectos
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <IconButton href="/notifications" sx={{ color: "text.secondary" }}>
                <NotificationIcon hasNewNotifications={hasNewNotifications} />
              </IconButton>
              <Typography variant="caption" fontSize={9} align="center">
                Notificaciones
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <IconButton href="/propuestas" sx={{ color: "text.secondary" }}>
                <TaskIcon />
              </IconButton>
              <Typography variant="caption" fontSize={9} align="center">
                Mis Propuestas
              </Typography>
            </Box>
          </Toolbar>
        </Toolbar>
      </AppBar>
      <Container sx={{ mt: { xs: 23, md: 4 }, mb: { xs: 20, md: 6 } }}>
        <Box sx={styles.buscar}>
          <TextField
            fullWidth
            label="Buscar por título"
            variant="outlined"
            value={nameSearch}
            onChange={handleNameSearchChange}
            sx={{ mb: 2, mr: 1 }}
          />
          <FormControl fullWidth>
            <InputLabel id="skill-select-label">
              Seleccionar habilidades
            </InputLabel>
            <Select
              labelId="skill-select-label"
              multiple
              value={selectedSkills}
              onChange={handleSkillChange}
              input={<OutlinedInput label="Seleccionar habilidades" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {allSkills.map((skill) => (
                <MenuItem key={skill} value={skill}>
                  {skill}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="sort-select-label">Ordenar por</InputLabel>
          <Select
            labelId="sort-select-label"
            label="Ordenar por"
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <SortIcon color="action" />
              </InputAdornment>
            }
          >
            <MenuItem value="recent">Más recientes</MenuItem>
            <MenuItem value="priceHigh">Mayor presupuesto</MenuItem>
            <MenuItem value="priceLow">Menor presupuesto</MenuItem>
          </Select>
        </FormControl>
        {!loading && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {filteredResults.length} proyecto{filteredResults.length !== 1 ? "s" : ""} disponible{filteredResults.length !== 1 ? "s" : ""}
          </Typography>
        )}
        <Box>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <CircularProgress />
            </Box>
          ) : filteredResults.length === 0 ? (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 6, color: "text.secondary" }}>
              <WorkOffIcon sx={{ fontSize: 48, mb: 1 }} />
              <Typography variant="body1">No se encontraron proyectos</Typography>
              <Typography variant="body2">Probá ajustando la búsqueda o los filtros</Typography>
            </Box>
          ) : (
            <List>
              {filteredResults.map((project) => (
                <ListItem key={project.id} sx={{ display: "block", px: 0 }}>
                  <Card
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      p: 3,
                      width: "100%",
                      ...(isFeaturedActive(project) && {
                        border: "1px solid",
                        borderColor: "#d4a017",
                      }),
                    }}
                  >
                    {isFeaturedActive(project) && (
                      <Chip
                        size="small"
                        icon={<StarIcon sx={{ color: "#d4a017 !important" }} />}
                        label="Destacado"
                        variant="outlined"
                        sx={{ borderColor: "#d4a017", color: "#d4a017", mb: 1 }}
                      />
                    )}
                    <Link onClick={handleProject(project.id)} sx={{ cursor: "pointer" }}>
                      <Typography sx={styles.title}>
                        {project.title}
                      </Typography>
                    </Link>
                    <TruncatedTypography sx={styles.description}>
                      {project.description}
                    </TruncatedTypography>
                    <Typography sx={styles.price}>
                      Presupuesto: USD$ {project.price}
                    </Typography>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, my: 1 }}>
                      {(Array.isArray(project.skills) ? project.skills : [project.skills]).map((skill) => (
                        <Chip key={skill} label={skill} size="small" variant="outlined" />
                      ))}
                    </Box>
                    <Typography sx={styles.skills}>
                      Usuario: {project.name}
                    </Typography>
                    <Typography sx={styles.timeToDo}>
                      Fecha de entrega: {formatDate(project.timeToDo)}
                    </Typography>
                    <Typography sx={styles.created}>
                      Publicado{" "}
                      {formatDistanceToNow(project.createdAt.toDate(), { addSuffix: true, locale: es })}
                    </Typography>
                    {myTier.maxProjectBudget >= (Number(project.price) || 0) ? (
                      <ProtectedPublishButton projectId={project.id}>
                        Enviar una propuesta
                      </ProtectedPublishButton>
                    ) : (
                      <Button
                        fullWidth
                        variant="outlined"
                        color="warning"
                        startIcon={<LockIcon />}
                        onClick={() => navigate("/subscription")}
                      >
                        Necesitás un plan superior para este proyecto
                      </Button>
                    )}
                  </Card>
                </ListItem>
              ))}
            </List>
          )}
        </Box>
        <BottomNav />
      </Container>
    </Container>
  );
};

export default Home;
